import React from "react";
import styled, { css } from "styled-components";
import { Breadcrumbs, Button, Dropdown, FormGroup, Icon, Input, Pill, Select, StatusDot } from "xsolla-uikit";
import { vi } from "../../data";
import { PAviItems } from "./PAviItems";





export default function PAviGroup({
  history,
  showAsPage,
  products = vi,
  appearance
}) {
  return (
    <div
    // className="xsui-width"
    >
      {showAsPage && <FormGroup>
        <Breadcrumbs
          limit={6}
          items={[
            {
              label: "In-game store",
              to: "/microtransactions/"
            },
            {
              label: "Virtual items",
              to: "/microtransactions/vi"
            },
            {
              label: "Weapons",
              to: "/microtransactions/vi/group_1"
            }
          ]}
        />
      </FormGroup>}

      <FormGroup indentation='lg'>
        {/* <ContentBlock> */}
          <div style={{position: 'relative', overflow:'visible'}}>
          {/* <Head appearance="separated">
            <FormGroup>
              Search Add
            </FormGroup>
          </Head> */}

          <FormGroup>


          <FormGroup
            // style={{position: 'sticky', top: 0, zIndex: 1}}
            extra={<Button appearance="secondary">+ Add new item</Button>}
          >
            <div style={{position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center',}}>
              <div
                style={{
                  width: 'auto', marginBottom: 10,
                  // marginLeft: 16
              }}>
                <Select
                // disabled={this.disabled}
                autosize={true}
                size="sm"
                name=""
                options={[
                  { label: "Grpoup: ungrouped", id: "all", value: "all", extraLabel: '41 items' },
                  { label: "Weapons", id: "wepons", value: "wepons", extraLabel: '23 items'  },
                  { label: "Armor", id: "armor", value: "armor", extraLabel: '39 items'  }
                ]}
                searchable={false}
                autosize={false}
                disabled={false}
                input={{
                  name: "test",
                  onChange: e => {
                    void 0;
                  },
                  value: 'all'
                }}
              />
              </div>

              {/* <div style={{flexGrow: 1, justifyContent: 'flex-end', display: 'flex'}}>
                <Button
                // appearance="outline-secondary"
                appearance="secondary"
                size="sm">+ New virtual item</Button>
              </div> */}

            </div>
          </FormGroup>





          <div style={{position: "static"}}>
            <PAviItems products={products} appearance={appearance}/>
          </div>
          </FormGroup>
          </div>
        {/* </ContentBlock> */}
      </FormGroup>
    </div>
  );
}



const CSSviItemLine = styled(PAviItemLine)`
  /* background-color: ${({active}) => active ? 'blue' : 'transparent'}; */
  /* background-color: red; */
`





export function PAviItemLine({
  active,
  appearance,
  status = 'enabled',
  opened = false,
  order,
  id = 159428,
  sku = "gun_1",
  localized_name = "Xsolla Basic Blaster 1",
  prices = {
    USD: 1.99
  },
  virtual_currency_price = null,
  default_currency = "USD",
  enabled = true,
  permanent = false,
  image_url = "//cdn3.xsolla.com/img/misc/images/0c59a7698d4f66c1008b27ee752089b7.png",
  advertisement_type = null,

  handleClick = ()=>{void(0)},
}) {




  return (
    <CssLineHover
      hover={true}
      popOpen={opened}
      // active={parseInt(active) === parseInt(order) ? true : false}
      active={active === order ? true : false}
      className="ui-table__body__row ui-table__body__row--sortable ui-table__body__row--v-align-center"
    >
      {!appearance && <CssClick
        onClick={(e) => {
          e.preventDefault();
          active === false && handleClick(order)
          active !== false && handleClick(false)
        }}
      />}

     <CssOpen
      popOpen={active}
      active={active === order ? true : false}
      className="xsui-open-panel"
      onClick={(e) => {
        e.preventDefault();
        handleClick(order)
      }}>
        <CssOpenRound
          className="xsui-open-panel-ind"
        >
        <Icon name="chevron" size={24}/>
        </CssOpenRound>
      </CssOpen>
      {/* } */}

      {/* <Link
        to={`/ingame/vi/group_1/item_${id}`} style={{color: 'currentColor'}}
        className="ui-table__body__row ui-table__body__row--sortable ui-table__body__row--v-align-center" data-id="table.rows[0]"
      > */}

        {appearance !== 'connector' && <div
          className="ui-table__column ui-table__column--indentation-sm"
          style={{ flexShrink: 0, width: 60 }}
        >
          <div className="ui-table__drag-handle" />
          <div className="virtual-items-row__order">{order}</div>
        </div>}


        <div
          className="ui-table__column ui-table__column--indentation-md"
          style={{ maxWidth: "45%" }}
        >
          <div className="virtual-items-row__name">
            <img
              className="virtual-items-row__name__image virtual-items-row__name__image--item"
              src={image_url}
            />

            <div className="virtual-items-row__name__info">
              {localized_name}
              <div data-id="vi.item.info">{sku}</div>
            </div>
          </div>
        </div>


        {appearance !== 'connector' && <div
          className="ui-table__column ui-table__column--indentation-sm"
          style={{ maxWidth: "15%" }}
        >
          <div>No label</div>
        </div>}


        <div
          className="ui-table__column ui-table__column--indentation-sm"
          style={{ maxWidth: "15%" }}
        >
          <div className="virtual-items-row__id">{prices["USD"]}</div>
        </div>




        {appearance === 'connector' && <div
        className="ui-table__column ui-table__column--indentation-sm"
        style={{ flexShrink: 0, width: "15%" }}
        >
          <Input
            input={{ name: "caption", value: sku, onChange: () => void 0 }}
            placeholder="Count"
            inline={true}
            disabled={true}
            // focused={true}
            size="sm"
          />
        </div>}

        {appearance === 'connector' && <div
        className="ui-table__column ui-table__column--indentation-sm"
        style={{ flexShrink: 0, width: "10%" }}
        >
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center',}}>
            <Icon
              name={(Math.random() * 10) > 5 ? 'checkmark' : 'exclamation-alert'}
              size={18}
            />
          </div>
        </div>}


        {appearance === 'connector' && <div
        className="ui-table__column ui-table__column--indentation-sm"
        style={{ flexShrink: 0, width: "15%" }}
        >
        <Input
            input={{ name: "caption", onChange: () => void 0 }}
            placeholder="Xbox SKU"
            inline={true}
            // focused={true}
            size="sm"
          />
        </div>}




        {appearance !== 'connector' && <div
          className="ui-table__column ui-table__column--indentation-sm"
          style={{ flexShrink: 0, width: "10%" }}
        >
            <Dropdown
              autosize={true}
              // separated={true}
              options={[
                {
                  label: 'Start selling',
                  // description: 'The button will start ',
                  customIcon: <StatusDot status="enabled" />,
                  // iconAlign: 'right'
                },
                {
                  label: 'Stop selling',
                  // description: 'Build will not be available for some devs',
                  customIcon: <StatusDot status="testing" />,
                  // iconAlign: 'right'
                }
              ]}>
              <Pill appearance={`${status !== 'draft' ? `active` : `info`}`} >
                {status !== 'draft' ? `Selling` : `Draft`}
              </Pill>
            </Dropdown>
        </div>}



        <div
          className="ui-table__column ui-table__column--indentation-sm"
          style={{ maxWidth: "10%", display: 'flex', justifyContent: 'flex-end', }}
        >

            <Dropdown
              align="right"
              autosize={true}
              separated={false}
              options={[
                {label: 'Settings', icon: 'settings'},
                {label: 'Delete', color: '#eb002f', icon: 'delete'}
              ]}>
              <Icon name="more" />
            </Dropdown>


        </div>

      {/* </Link> */}

    </CssLineHover>
  );
}




export const CssTable = styled.div`
  transition: all 150ms ease-in-out;
  ${({open}) => open && css`
    /* padding-right: 380px; */
  `};
`





export const CssViZ = styled.div`
  transition: all 250ms ease-in-out;
  &:hover {
    opacity: 0.6;
  }
`





const CssClick = styled.div`
  position: absolute;
  cursor: pointer;
  right: 260px;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 9;

`






export const CssLineHover = styled.div`
  padding: 24px 32px 24px 16px;
  background-color: ${({active}) => active ? '#e4ebf9' : 'transparent'};
  /* position: ${({active}) => active ? 're' : 'auto' }; */
  /* position: ${({active}) => active ? 'relative' : 'static' }; */
  /* position: static; */
  z-index: ${({active}) => active ? '10' : 'auto' };

  &:hover {
    background-color: ${({active}) => !active ? '#e4ebf9' : 'transparent'};
    ${({active}) => active && css`
      background-color: #f2f6ff;
    `};
  }


  ${({popOpen}) => popOpen !== false && css`
    transition: all 150ms ease-in-out;

    & .xsui-open-panel {
        z-index: 10;
        opacity: 0;
    };
    & .xsui-open-panel {
      ${({active, popOpen}) => active && popOpen && css`
        opacity: 1;
      `}
    }

    &:hover .xsui-open-panel {
      ${({popOpen}) => popOpen !== false && css`
        opacity: 0.6;
      `}
      ${({active, popOpen}) => active && popOpen && css`
        opacity: 1;
      `}
    };

  `};


`





const CssOpen = styled.div`
  position: absolute;
  /* right: 540px; */
  right: 560px;
/* border: 1px solid red; */
  width: 300px;
  z-index: -10;

  opacity: 0;
  transition: all 150ms ease-in-out;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;

  & .xsui-open-panel-ind {
    transition: all 150ms ease-in-out;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 44px;
    height: 44px;
    border-radius: 1000px;
    color: white;
    border: 1px solid white;
  };

  &:hover .xsui-open-panel-ind {
    transform: translateX(8px);
    border: 1px solid white;
  }
  &:hover .xsui-open-panel-ind:hover  {
    opacity: 1;
    background-color: white;
    color: black;
  }




  ${({active, popOpen}) => active && css`
    opacity: 1;
    z-index: 10;

      & .xsui-open-panel-ind {
        opacity: 1;
        background-color: white;
        color: black;
      }

  `}


  cursor: pointer;
`

const CssOpenRound = styled.div`


`


















